import Instance from "../../../../Axios";

// New Actions for the app

const GetCredCopiaCredenciacaoUploaded = (credId) => async (dispatch) => {
  await Instance()
    .get(`/credenciacoes/copiaCredenciacao/${credId}`)
    .then(({ data }) => {
      dispatch({
        type: "GET_CRED_COPIA_CRECENCIACAO_UPLOADED",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetCredCopiaCredenciacaoUploaded;
